import API from 'services/TAPS_API/index';

export default function getCameralYearsList() {
  return API.request({
    method: 'GET',
    url: `/notification/1151020/cameral/list-years`,
  });
}
